import {useDispatch, useSelector} from "react-redux";
import {useNavigate} from "react-router-dom";
import React from "react";
import {hasRight} from "../../../../Common/UserCommon";
import {initFormHandler} from "../../../../Handler/FormHandler";
import {makeStyles} from "@mui/styles";
import {
    LinearProgressMainLayoutActivate,
    LinearProgressMainLayoutDeactivate
} from "../../../../Action/LinearProgressMainLayoutAction";
import ApiHandler from "../../../../Handler/ApiHandler";
import {SnackbarOpen} from "../../../../Action/SnackbarAction";
import {getRoutePathname} from "../../../../Handler/RouteHandler";
import ShadowBoxComponent from "../../../../Component/ShadowBoxComponent";
import TitleComponent from "../../../../Component/TitleComponent";
import {Grid} from "@mui/material";
import TextFieldComponent from "../../../../Component/TextFieldComponent";
import SelectComponent from "../../../../Component/SelectComponent";
import ButtonComponent from "../../../../Component/ButtonComponent";
import CheckboxComponent from "../../../../Component/CheckboxComponent";

function ClientBusinessForm(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [optionsUser, setOptionsUser] = React.useState([]);
    const [optionsCountry, setOptionsCountry] = React.useState([]);
    const authenticationReducer = useSelector(state => state.AuthenticationReducer);
    const justWatch = !hasRight(authenticationReducer, 'ROLE_SHOP_MANAGEMENT_SHOP') && !hasRight(authenticationReducer, 'ROLE_SHOP_MANAGEMENT_SHOP_EDIT');

    const [form, setForm] = React.useState({
        socialName: {
            name: 'socialName',
            label: 'Raison sociale',
            textHelper: 'Saisissez la raison sociale',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        website: {
            name: 'website',
            label: 'Site internet',
            textHelper: 'Saisissez l\'url du site internet',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        siren: {
            name: 'siren',
            label: 'Siren',
            textHelper: 'Saisissez le siren',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        pendingAmountMax: {
            name: 'pendingAmountMax',
            label: 'Montant max HT en attente de paiement',
            textHelper: 'Saisissez le montant.',
            type: 'integer',
            defaultValue: '',
            options: {validation: ['required']}
        },
        address: {
            name: 'address',
            label: 'Adresse',
            textHelper: 'Saisissez l\'adresse du business.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        country: {
            name: 'country',
            label: 'Pays',
            textHelper: 'Choisissez le pays du business.',
            type: 'integer',
            defaultValue: '',
            options: {validation: ['required']}
        },
        city: {
            name: 'city',
            label: 'Ville',
            textHelper: 'Saisissez la ville du business.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        department: {
            name: 'department',
            label: 'Département',
            textHelper: 'Saisissez le département du business.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        region: {
            name: 'region',
            label: 'Région',
            textHelper: 'Saisissez la région du business.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        zipCode: {
            name: 'zipCode',
            label: 'Code postal',
            textHelper: 'Saisissez le code postal.',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
        assignedTo: {
            name: 'assignedTo',
            label: 'Assigné à',
            textHelper: 'Choisissez l\'utilisateur qui s\'occupe de ce business',
            type: 'integer',
            defaultValue: '',
            options: {validation: ['required']}
        },
        email: {
            name: 'email',
            label: 'Email',
            textHelper: 'Saisissez l\'email',
            type: 'text',
            defaultValue: '',
            options: {validation: ['required']}
        },
    });
    const [isLoadingForm, setIsLoadingForm] = React.useState(false);
    const handlerForm = initFormHandler(form, setForm);

    const save = () => {
        if (handlerForm.checkError() < 1) {
            handlerForm.setFormLoading(true);
            setIsLoadingForm(true);
            dispatch(LinearProgressMainLayoutActivate());

            if (props.clientBusiness) {
                ApiHandler.post({
                    route: 'api_b2b_client_business_edit',
                    data: handlerForm.getData(),
                    params: {id: props.clientBusiness[0].id}
                }, (response) => {
                    if (response.status === 200) {
                        dispatch(
                            SnackbarOpen({
                                text: 'Business modifié avec succès.',
                                variant: 'success',
                            })
                        );
                    }
                    else if (response.status === 400) {
                        handlerForm.setErrorApi(response.error);
                    }
                    else {
                        dispatch(
                            SnackbarOpen({
                                text: response.error && response.error.message ? response.error.message : 'Une erreur inattendue s\'est produite.',
                                variant: 'error',
                            })
                        );
                    }
                    dispatch(LinearProgressMainLayoutDeactivate());
                    handlerForm.setFormLoading(false);
                    setIsLoadingForm(false);
                });
            }
            else {
                ApiHandler.post({
                    route: 'api_b2b_client_business_add',
                    data: handlerForm.getData()
                }, (response) => {
                    if (response.status === 200) {
                        navigate(getRoutePathname('b2b_client_business_list'));
                        dispatch(
                            SnackbarOpen({
                                text: 'Business créé avec succès.',
                                variant: 'success',
                            })
                        );
                    }
                    else if (response.status === 400) {
                        handlerForm.setErrorApi(response.error);
                    }
                    else {
                        dispatch(
                            SnackbarOpen({
                                text: response.error && response.error.message ? response.error.message : 'Une erreur inattendue s\'est produite.',
                                variant: 'error',
                            })
                        );
                    }
                    dispatch(LinearProgressMainLayoutDeactivate());
                    handlerForm.setFormLoading(false);
                    setIsLoadingForm(false);
                });
            }
        }
    };
    React.useEffect(handlerForm.start, []);
    React.useEffect(() => {
        if (props.clientBusiness) {
            handlerForm.setDataApi(props.clientBusiness[0]);
        }
    }, []);
    React.useEffect(() => {
        handlerForm.setFormLoading(justWatch);
    }, [justWatch]);

    React.useEffect(() => {
        ApiHandler.get({route: 'api_select_country'}, (response) => {
            let data = [{value: '', label: ''}, ...response.data];
            setOptionsCountry(data)
        });
        ApiHandler.get({route: 'api_select_user'}, (response) => {
            let data = [{value: '', label: ''}, ...response.data];
            setOptionsUser(data)
        });
    }, []);

    return (
        <ShadowBoxComponent className={classes.shadowBox}>
            <TitleComponent title={'Information business'}/>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'website'} handler={handlerForm}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'email'} handler={handlerForm}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'socialName'} handler={handlerForm}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'siren'} handler={handlerForm}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'pendingAmountMax'} handler={handlerForm}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'address'} handler={handlerForm}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <SelectComponent id={'country'} options={optionsCountry} handler={handlerForm}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'city'} handler={handlerForm}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'department'} handler={handlerForm}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'region'} handler={handlerForm}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextFieldComponent id={'zipCode'} handler={handlerForm}/>
                </Grid>
                <Grid item xs={12} sm={3}>
                    <SelectComponent id={'assignedTo'} options={optionsUser} handler={handlerForm}/>
                </Grid>
            </Grid>

            {!justWatch && <ButtonComponent label={'Enregistrer'} className={classes.button} onClick={save} loading={isLoadingForm}/>}
        </ShadowBoxComponent>
    );
}

const useStyles = makeStyles({
    shadowBox: {
        paddingBottom: 45,
        height: '100%'
    },
    button: {
        margin: '15px !important',
        bottom: '0 !important',
        right: '0 !important',
        position: 'absolute !important'
    },
    owner: {
        backgroundColor: '#9c27b0',
        color: '#FFF',
        borderRadius: 25,
        padding: '5px 10px',
        marginLeft: 10,
        fontSize: 11,
        position: 'absolute',
        top: 7,
        right: 14
    }
});

export default ClientBusinessForm;